/**
 * A submit button's "Processing..." state, as on Register, for buttons that carry
 * data-loading-text. Shown only once the form has passed validation, so a button never sits
 * disabled behind a field the booker still has to fix; reset it if the step then fails
 * client-side (e.g. saving to session).
 */
export function showButtonLoading(button: HTMLButtonElement | null | undefined): void {
    if (!button || button.dataset.loadingActive === "true") return;

    button.dataset.loadingActive = "true";
    button.dataset.originalText = button.textContent ?? "";
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    if (button.dataset.loadingText) {
        button.textContent = button.dataset.loadingText;
    }
}

export function resetButtonLoading(button: HTMLButtonElement | null | undefined): void {
    if (!button || button.dataset.loadingActive !== "true") return;

    button.textContent = button.dataset.originalText ?? button.textContent;
    button.disabled = false;
    button.removeAttribute("aria-busy");
    delete button.dataset.loadingActive;
    delete button.dataset.originalText;
}

// Coming back to the page with the browser's Back button restores it as it was left, still
// saying "Processing...", so the buttons are put back.
window.addEventListener("pageshow", e => {
    if (e.persisted) {
        document.querySelectorAll<HTMLButtonElement>("button[data-loading-active='true']").forEach(resetButtonLoading);
    }
});
